//  The steps for the Modify flow are conditional,
import { ModificationTypes } from '../../../types/briefing';
import { Step } from '../../../types/misc';

//  based on a user selection that is saved to the briefing state
export const getStepsForModifyFlowForHCIC = (
  modifyType: ModificationTypes | null,
): Step[] => {
  const colourSelected = modifyType?.includes('colour');
  const fragranceSelected = modifyType?.includes('fragrance');
  const baseSelected = modifyType?.includes('base');

  const firstStep: Step[] = ['modification-type'];
  const baseFormulationSteps: Step[] = [
    'modification-issue',
    'application',
    'formulation-attributes',
    'ingredients',
    'requirements',
  ];
  const colourSteps: Step[] = ['colour'];
  const fragranceSteps: Step[] = ['fragrance'];

  let steps: Step[] = ['price', 'product-details', 'additional-info', 'review'];

  if (fragranceSelected) {
    steps = [...fragranceSteps, ...steps];
  }

  if (colourSelected) {
    steps = [...colourSteps, ...steps];
  }

  if (baseSelected) {
    steps = [...baseFormulationSteps, ...steps];
  }

  return [...firstStep, ...steps];
};
